import { CustomStep } from "../warehouseJoyrideSteps";
import JoyrideTooltipContentWrapper from "../components/JoyrideTooltipContentWrapper";
import JoyrideTooltip from "../../JoyrideTooltip/JoyrideTooltip";
import { WarehouseTutorialType } from "../../../../utils/enums";
import CreateProductFormStep from "../StepsComponents/CreateProductFormStep";
import WarehouseSelectionStep from "../StepsComponents/WarehouseSelectionStep";
import SimpleContentStep from "../StepsComponents/SimpleContentStep";
import AddProductToWarehouseFormStep from "../StepsComponents/AddProductToWarehouseFormStep";
import TutorialTransStep from "../StepsComponents/TutorialTransStep";
import React from "react";

export const getProductMovementConfigArray = (
    branchId: string,
    hasProducts?: boolean,
    goNext?: () => void
): CustomStep[] => {
    const windowWidth = window?.innerWidth;

    return [
        // step 0
        {
            target: "[data-tour='create-product-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper
                        hasProducts={hasProducts}
                        skipCreateProductRout={`/warehouses/branch/${branchId}`}
                    >
                        <SimpleContentStep text='Click the "Add product" button' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
        },
        // step 1
        {
            target: "[data-tour='create-product-form']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <CreateProductFormStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1780 ? "left" : "top",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            isFixed: true,
            observeResize: true,
            pageScrollReposition: true,
            disableScrollParentFix: false,
        },
        // step 2
        {
            target: "[data-tour='product-created']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext route={`/warehouses/branch/${branchId}`}>
                        <SimpleContentStep text="The product has been created!" fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
        },

        // step 3
        {
            target: "[data-tour='warehouse-selection']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <WarehouseSelectionStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1780 ? "left-start" : "top",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 4
        {
            target: "[data-tour='add-products-to-warehouse-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <SimpleContentStep text='Click "Add product to warehouse"' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 5
        {
            target: "[data-tour='add-product']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <SimpleContentStep text='Click "+" to add' fw="bold" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            observeResize: true,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 6
        {
            target: "[data-tour='add-product-to-warehouse-form']",
            headroomTarget: ".add-product-to-warehouse",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <AddProductToWarehouseFormStep />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1650 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1650 ? "left" : "top",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            headroomRules: [{ maxW: 1650, top: 170, bottom: 160 }],
            styles: {
                options: {
                    zIndex: 1200,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 7
        {
            target: "[data-tour='added-product-to-warehouse']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext>
                        <SimpleContentStep text="Your product is now in stock!" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1650 ? "left" : "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
        },
        // step 8
        {
            target: "[data-tour='actions-with-goods-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext>
                        <SimpleContentStep text="Actions with products in the warehouse. You can restock, write off, or move products between the branch's warehouses." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
            placement: "bottom",
        },
        // step 9
        {
            target: "[data-tour='write-off-product-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="minusBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
            spotlightPadding: 6,
        },
        // step 10
        {
            target: "[data-tour='write-off-product-form']",
            headroomTarget: ".write-off-product",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNextId="warehouse-action-modal-handler">
                        <TutorialTransStep
                            translationKey="writeOffForm"
                            icon={
                                <span>
                                    {" "}
                                    (<span className="text-danger">*</span>){" "}
                                </span>
                            }
                        />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1650 ? "left" : "bottom",
            floaterProps: {
                placement: windowWidth > 1650 ? "left" : "bottom",
                disableFlip: false,
            },
            isFixed: false,
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            observeResize: true,
            styles: {
                options: {
                    zIndex: 1500,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 11
        {
            target: "[data-tour='movement-product-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="movementBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            placement: "bottom",
            spotlightPadding: 6,
        },
        // step 12
        {
            target: "[data-tour='movement-product-form']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper
                        showNext
                        route={`/warehouse/reports/branch/${branchId}`}
                        goNext={goNext}
                    >
                        <TutorialTransStep
                            translationKey="movementForm"
                            icon={
                                <span>
                                    {" "}
                                    (<span className="text-danger">*</span>){" "}
                                </span>
                            }
                        />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1650 ? "left" : "bottom",
            floaterProps: {
                placement: windowWidth > 1650 ? "left" : "bottom",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: true,
            observeResize: true,
            headroomRules: [{ maxW: 1650, top: 250, bottom: 250 }],
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 13
        {
            target: "[data-tour='reports']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext route={`/warehouses/operations/${branchId}`}>
                        <SimpleContentStep text="Here you can view the history of goods movements and generate reports." />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 745 ? "left" : "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            disableScrolling: true,
            observeResize: true,
        },
        // step 14
        {
            target: "[data-tour='operations']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext>
                        <SimpleContentStep text="Here you can view all transactions with goods in the branch's warehouses" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1780 ? "left" : "top",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
            observeResize: true,
            pageScrollReposition: true,
            headroomRules: [{ maxW: 1650, top: 80 }],
        },
        // step 15
        {
            target: "[data-tour='edit-operation-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="editOperationBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: "bottom",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
        },
        // step 16
        {
            target: "[data-tour='edit-operation-form']",
            headroomTarget: ".edit-operation",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper showNext goNextId="edit-operation-modal-handler">
                        <TutorialTransStep
                            translationKey="editOperationForm"
                            icon={
                                <span>
                                    {" "}
                                    (<span className="text-danger">*</span>){" "}
                                </span>
                            }
                        />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            placement: windowWidth > 1650 ? "left" : "top",
            floaterProps: {
                placement: windowWidth > 1650 ? "left" : "top",
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 0,
            disableScrollParentFix: false,
            pageScrollReposition: true,
            observeResize: true,
            headroomRules: [{ maxW: 1650, top: 280, bottom: 300 }],
            styles: {
                options: {
                    zIndex: 960,
                    overlayColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        // step 17
        {
            target: "[data-tour='history-operation-btn']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper>
                        <TutorialTransStep translationKey="operationChangeHistoryBtn" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightPadding: 6,
            placement: "bottom",
        },
        // step 18
        {
            target: "[data-tour='history-changes']",
            content: (
                <JoyrideTooltip>
                    <JoyrideTooltipContentWrapper btnNextTutorial={WarehouseTutorialType.CONSUMABLES_WRITE_OFF}>
                        <SimpleContentStep text="Here you can view the history of changes in warehouse operations" />
                    </JoyrideTooltipContentWrapper>
                </JoyrideTooltip>
            ),

            placement: "bottom",
            floaterProps: {
                disableFlip: false,
            },
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            spotlightClicks: false,
            observeResize: true,
        },
    ];
};
